import { PDFViewer } from "@react-pdf/renderer";
import React from "react";
import { Modal } from "react-bootstrap";
import DraftPermohonan from "../../cetak/draft/DraftPermohonan";

const ModalCetakPermohonan = ({showCetak, handleCloseCetak, datappm}) => {

    return (
        <>
            <Modal
                show={showCetak}
                onHide={handleCloseCetak}
                keyboard={false}
                size="xl"
                centered
            >
                <Modal.Body>
                    <PDFViewer
                        style={{width: 1105, height: 800}}
                    >
                        <DraftPermohonan datappm={datappm}/>
                    </PDFViewer>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalCetakPermohonan